import React from 'react'

const Angle = () => (
    <svg width="100%" height="172" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2560 350L0 0V350H2560Z" fill="#EEEEEE"/>
    </svg>

    
)

export default Angle


// WEBPACK FOOTER //
// ./src/components/Angle.js